module.exports = __webpack_public_path__ + "static/bathroom-76a374e3ba7ca2ed0228de8b94dcd547.jpg";